import { useEffect } from 'react';

import Link from 'next/link';
import { useRouter } from 'next/router';

// export const getStaticProps = async () => {
//   return {
//     props: {
//     },
//   };
// };

export default function Redirect() {
  const router = useRouter();
  useEffect(() => {
    router.push('/en/');
  });

  return (
    <>
      <div className='container relative mx-auto font-sans text-white md:grid md:grid-cols-24 md:gap-0'>
        <div className='hidden lg:col-span-2 lg:block'></div>
        <div className='relative px-4 xs:px-8 md:col-span-24 lg:col-span-20 lg:px-0'>
          <section className='lg:min-h-hero relative min-h-screen md:pt-[130px]'>
            <div className='absolute top-[50%] flex w-full flex-col justify-between text-center sm:items-center xl:flex-row'>
              <p className='mx-auto mb-8 px-2 text-2xl font-medium'>
                If not redirected to the Home Page in a few seconds, please{' '}
                <Link href='/en/' className='text-blue-400'>
                  click here.
                </Link>
              </p>
            </div>
          </section>
        </div>
        <div className='hidden lg:col-span-2 lg:block'></div>
      </div>
    </>
  );
}
